import { organizationConstants } from '../constants'

export const organizationLoad = () => {
  return {
    type: organizationConstants.ORGANIZATION_LOAD
  }
}

export const organizationLoadSuccess = (payload) => {
  return {
    type: organizationConstants.ORGANIZATION_LOAD_SUCCESS,
    payload
  }
}

export const organizationLoadFailure = (payload) => {
  return {
    type: organizationConstants.ORGANIZATION_LOAD_FAILURE,
    payload
  }
}

export const organizationReset = () => {
  return {
    type: organizationConstants.ORGANIZATION_RESET
  }
}

export const organizationSave = (payload) => {
  return {
    type: organizationConstants.ORGANIZATION_SAVE,
    payload
  }
}

export const organizationSaveSuccess = (payload) => {
  return {
    type: organizationConstants.ORGANIZATION_SAVE_SUCCESS,
    payload
  }
}

export const organizationSaveFailure = (payload) => {
  return {
    type: organizationConstants.ORGANIZATION_SAVE_FAILURE,
    payload
  }
}

export const organizationJoin = (payload) => {
  return {
    type: organizationConstants.ORGANIZATION_JOIN,
    payload
  }
}

export const organizationJoinSuccess = (payload) => {
  return {
    type: organizationConstants.ORGANIZATION_JOIN_SUCCESS,
    payload
  }
}

export const organizationJoinFailure = (payload) => {
  return {
    type: organizationConstants.ORGANIZATION_JOIN_FAILURE,
    payload
  }
}
